import React from 'react'

const SvgPenFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17 2.74c.948-.94 1.892-.94 2.832.003 1.41 1.412-.002-.004 1.411 1.41.943.945.943 1.887 0 2.83L18.415 9.81l-4.243-4.243 2.829-2.828H17zm-4.07 4.07l4.243 4.243L7.1 21.123l-3.844.78a1.167 1.167 0 01-.89-.196c-.268-.186-.373-.517-.315-.994l.807-3.831L12.929 6.81h.001z'
    />
  </svg>
)

export default SvgPenFilled
